import cx from 'classnames';
import React, { forwardRef } from 'react';
import { ConditionalView } from '../../utils/ConditionalView';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import Button from '../Button';
import styles from './ToggleButton.module.scss';
import usePresenter from './ToggleButton.presenter';
import { ToggleButtonProps } from './ToggleButton.types';

const ToggleButton = forwardRef<HTMLInputElement, ToggleButtonProps>((props, ref) => {
  const {
    otherProps,
    isChecked,
    handleChange,
    disabled,
    required,
    invalid,
    className,
    appearance,
    style,
    size,
    id,
  } = usePresenter(props);

  return (
    <>
      <input
        type="checkbox"
        className={styles.input}
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        ref={ref}
        id={id}
        aria-invalid={invalid}
      />
      <Button
        {...otherProps}
        className={cx(styles.toggleButton, {
          [styles.checked]: isChecked,
        }, className)}
        appearance={appearance}
        style={style}
        size={size}
        type={isChecked ? 'Filled' : 'Outlined'}
        onClick={() => handleChange({ target: { checked: !isChecked } } as React.ChangeEvent<HTMLInputElement>)}
        disabled={disabled}
        actionType='button'
      >
        <ConditionalView condition={props.children}>
          <WrapTextNodes>
            {props.children}
          </WrapTextNodes>
        </ConditionalView>
      </Button>
    </>
  );
});

export default ToggleButton;